<template lang='pug'>
    div 系统发送给个人的消息
</template>

<script>
// Generated by CoffeeScript 2.3.0
var m;

export default m = {
  props: {
    projectId: String
  },
  data: function() {
    return {
      opts: {
        tableName: 'offers',
        columns: [
          {
            label: '序号',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '项目编号',
            sortable: 'custom'
          },
          {
            label: '模块',
            sortable: 'custom'
          },
          {
            label: '职位',
            sortable: 'custom'
          },
          {
            label: '职级',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '客户',
            sortable: 'custom'
          },
          {
            label: '候选人',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '本次发票金额',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '固定年薪',
            sortable: 'custom'
          },
          {
            label: '佣金比例',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '佣金额',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '开票批次',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '开票比例',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '预计到岗时间',
            sortable: 'custom'
          },
          {
            label: '正式到岗时间',
            sortable: 'custom'
          },
          {
            label: '付款通知书编号',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '是否开具发票',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '发票寄出日期',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '回款日期',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '此单保证期',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '分成比例',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '提成发放',
            sortable: 'custom',
            hidden: true
          },
          {
            label: '备注',
            sortable: 'custom'
          }
        ],
        maxItem: 1000,
        expandable: true,
        trackable: true,
        filter: {
          'project._id': this.projectId
        },
        defaultItem: {
          project: {
            _id: this.projectId
          }
        }
      }
    };
  }
};
</script>


              

